const removeDiacritics = (value: string): string =>
    value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

export const sanitizeUsername = (value: string): string =>
    removeDiacritics(value)
        .toLowerCase()
        .trim()
        .replace(/\s+/g, '')
        .replace(/[^a-z0-9@._-]/g, '');

const sanitizeUsernameFromName = (value: string): string =>
    removeDiacritics(value)
        .toLowerCase()
        .replace(/[^a-z0-9]/g, '');

export const buildAutomaticUsername = (email?: string, name?: string, salt?: string): string => {
    const sanitizedEmail = sanitizeUsername(email ?? '');

    if (sanitizedEmail) {
        return sanitizedEmail;
    }

    const sanitizedName = sanitizeUsernameFromName(name?.trim() ?? '');
    const sanitizedSalt = sanitizeUsernameFromName(salt?.trim() ?? '');

    if (!sanitizedName) {
        return '';
    }

    return sanitizedSalt ? `${sanitizedName}.${sanitizedSalt}` : sanitizedName;
};
